import flex from "../../../../styles/flex";

export default {
    listItem: {
        backgroundColor: "white",
        position: "relative",
        border: "solid 1px lightgray",
        padding: 20,
        marginBottom: 10,
        transition: "all 0.2s ease-in-out 0s",
        textAlign: "left",
        borderRadius: 5,
        cursor: "pointer"
    } as React.CSSProperties,

    listItemFlex: {
        ...flex.flexRows,
        justifyContent: "center",
        itemsAlign: "center",
        alignContent: "center",

    } as React.CSSProperties,

    border: {
        border: "solid 1px grey",
        borderLeft: "solid 15px grey",
    } as React.CSSProperties,
    borderSystem: {
        border: "solid 1px orange",
        borderLeft: "solid 15px orange",
    } as React.CSSProperties,
    icon: {
        fontSize: 24,
        marginLeft: 20,
        marginRight: 20
    } as React.CSSProperties,
    iconChevron: {
        fontSize: 24,
        marginLeft: 20,
        marginRight: 10
    } as React.CSSProperties,


}